import React from 'react'
import '../styles/article.css'

const Chapter8 = () => {
    return (
        <div className='history-page'>
            <h1 className='history-chapter-lbl'>Chapter 8</h1>
            <h1 className='history-heading'>The Rise of Festivals and Competitions in Show Choir</h1>


            <div className='paragraphwimage-large'>

                <div className='imagewborder'>
                    <img src='images/history/13.jpg' alt='show choir' />
                </div>

                <p>The late 1960s and early
                    1970s marked the
                    beginning of formalized
                    festivals and competitions
                    for show choirs, offering a
                    new platform for this
                    burgeoning art form. The
                    first major event was the
                    Northwest Swing Choir Festival, launched in 1968 by Hal
                    Malcolm, then Director of Choral Activities at Mt. Hood
                    Community College in Oregon. Malcolm’s vision was to create
                    a festival celebrating vocal jazz music. However, at the time,
                    the term "jazz" was controversial in educational contexts, so
                    Malcolm used “swing” instead, giving birth to the Northwest
                    Swing Choir Festival.</p>
            </div>





            <p> Though Malcolm’s festival avoided the term “competition,” the
                event had all the elements of one. Adopting criteria inspired by
                the National Association of Jazz Educators (NAJE), Malcolm’s
                adjudication sheets provided comments or ranked groups
                based on vocal quality rather than staging or choreography.
                While staging was often included in performances, it was not a
                judging category; Malcolm’s goal was to focus strictly on the
                music. Pop songs were common due to limited knowledge of
                jazz repertoire, and directors often selected familiar Broadway
                tunes for their choirs.</p>
            <p>Following the success of the Northwest Swing Choir Festival,
                Dr. John Carrico from the University of Nevada, Reno invited
                Malcolm to help create a similar event. In 1971, Carrico
                founded the Reno Jazz Festival, which introduced a critical
                new feature: a separate adjudication category for "Show-Pop"
                groups, emphasizing staging and choreography. Unlike the
                Northwest Festival, Reno allowed groups to compete in either
                Vocal Jazz or Show-Pop divisions, catering to both traditional
                choral standards and the growing trend of incorporating visual
                elements. Audiences responded enthusiastically, especially to
                the high-energy Show-Pop performances, creating a clear
                demand for show choir competitions.</p>

            <h2 className='sub-head'>The Bishop Luers Swing Choir Contest: A Game Changer</h2>
            <p>In 1975, a major turning point came with the founding of the
                Bishop Luers High School Swing Choir Contest in Fort Wayne,
                Indiana, led by Father Fred Link. Inspired by the excitement
                generated by marching band competitions, Father Link
                envisioned a similar event for swing choirs. Unlike the
                Northwest and Reno festivals, the Bishop Luers contest
                focused solely on show choir, judging not only vocal skills but
                also choreography, costumes, and overall production value.
                The Bishop Luers competition became the blueprint for future
                show choir contests, establishing a format that emphasized all
                aspects of performance. Groups performed pop, rock,
                Broadway, country, and jazz music, with dynamic staging that
                was not only allowed but encouraged. By 1976, the
                competition had gained significant attention, with WBGU-TV
                from Bowling Green, Ohio, broadcasting an edited version of
                the contest throughout the Midwest. By 1982, the Bishop
                Luers contest was televised nationwide, and by 1985, it was
                aired internationally in the Soviet Union, where it received
                acclaim from Russian audiences. This exposure set new
                standards for show choir and elevated its popularity.</p>
            <p>Winning the Bishop Luers competition carried prestige, and its
                high standards pushed groups to refine their skills. Successful
                choirs displayed excellence in five areas: singing, instrumental
                accompaniment, movement, showmanship, and general effect
                (including transitions, pacing, and show design). Bishop Luers
                winners introduced more complex staging, from simple
                footwork to elaborate jazz dance steps, tricks, and lifts,
                transforming show choir into an art form that demanded a
                well-rounded theatrical skill set.</p>

            <h2 className='sub-head'>The Expanding Role of Competitions in Show Choir
                Culture</h2>
            <p>As the number of show choir competitions increased, these
                events fulfilled several needs that traditional concerts did not.
                First, competitions provided a critical learning environment
                where choirs performed for expert judges and received
                feedback on vocals, choreography, and instrumental
                accompaniment. Second, competitions drew large audiences,
                making them popular community events and effective
                fundraisers. Schools found that ticket sales, concessions, and
                merchandise sales supported choir programs, while
                enthusiastic fans gave students a taste of the excitement
                associated with athletic events.</p>
            <p>By the end of the 1970s, show choir had evolved from simple
                swing choirs into full-fledged productions with specialized
                choreography, costumes, and sets. Directors began to take on
                the role of producers, hiring choreographers, arrangers,
                costume designers, and even set builders. As show choirs
                became more elaborate, they also became more expensive to
                operate, relying heavily on booster programs and fundraising
                efforts to cover costs.</p>
            <p>The rise of competitions and festivals was instrumental in
                shaping modern show choir. Directors now had a venue to
                showcase their creativity, and students had an outlet to
                express themselves through a fusion of song, dance, and
                showmanship. The excitement surrounding competitions
                helped solidify show choir as a unique and respected art form
                within music education, transforming choral performance into
                a multimedia experience that would continue to grow and
                evolve in the decades to come.</p>



        </div>
    )
}

export default Chapter8